export default {
  'август': 'agosto',
  'Авто и мото': 'Auto e Moto',
  'Аксессуары': 'Acessórios',
  'Акции и промокоды': 'Promoções e cupoms de desconto',
  'Акции': 'Promoções',
  'акция': 'Ofertas',
  'апрель': 'abril',
  'А так же воспользуйтесь Кэшбеком, чтобы сэкономить еще больше!': 'Opcional use o cashback, para economizar ainda mais.',
  'Банки и финансы': 'Bancos e finanças',
  'в других странах': 'em outros países',
  'В избранное': 'Para favoritos',
  'Вакансии': 'Vagas',
  'Ваш голос учтен, спасибо': 'Seu voto contado, obrigado',
  'Введите название магазина, например': 'Procure pelas lojas aqui, por exemplo',
  'Все промокоды': 'Todos os cupom de desconto',
  'Главная': 'Início',
  'д.': 'd.',
  'Да': 'Sim',
  'Действует': 'Válido',
  'Действует до': 'Válido até',
  'декабрь': 'dezembro',
  'Детские товары': 'Produtos infantis',
  'Для взрослых': 'Para adultos',
  'Для офиса': 'Para o escritório',
  'Добавлено в избранное': 'Favorito',
  'Дом и сад': 'Casa e jardim',
  'Еда и напитки': 'Comida e bebidas',
  'Животные и растения': 'Animais e plantas',
  'за': 'de',
  'Здоровье и красота': 'Saúde e Beleza',
  'Игры': 'Jogos',
  'июль': 'julho',
  'июнь': 'junho',
  'Как это работает': 'Como funciona',
  'Категории': 'Categorias',
  'Книги': 'Livros',
  'Контакты': 'Contatos',
  'Копировать': 'Copiar',
  'Криптовалюты': 'Moedas criptografadas',
  'Кэшбэк': 'Cashback',
  'кэшбэка дополнительно': 'de reembolso extra',
  'Лучшие предложения по кэшбэку': 'As melhores ofertas para cashback',
  'Магазины': 'Lojas',
  'май': 'maio',
  'март': 'março',
  'Мебель': 'Móveis',
  'Меньше': 'Menos',
  'Мобильные приложения': 'Aplicativos móveis',
  'Моллы': 'Centros comerciais',
  'Музыка и фильмы': 'Música e Filmes',
  'Нажмите "Показать промокод" скопируйте его и используйте': 'Clique em "Mostrar cupom" copie e use quando comprar.',
  'Найдите нужный вам магазин, через наш поиск': 'Use os mecanismos de busca para encontrar a loja onde pretende fazer uma compra',
  'Нет': 'Não',
  'ноябрь': 'novembro',
  'О нас': 'Sobre nós',
  'Облачный майнинг': 'Mineração em nuvem (cloud mining)',
  'Обувь': 'Calçado',
  'Одежда': 'Vestuário',
  'октябрь': 'outubro',
  'оценка': 'pontos',
  'Перейти в магазин': 'Vá para a loja',
  'Подберите промокод, который вам подходит': 'Na página da loja selecione cupom de desconto, que corresponde ao seu produto e o valor do pedido',
  'Показать ещё': 'Ver mais',
  'Показать код': 'Ver Cupom',
  'Показать промокод': 'Ver Cupom',
  'Получите до': 'Obtenha até',
  'Получить': 'Obter',
  'Получить скидку': 'Ver desconto',
  'Пользовательское соглашение': 'O contrato do usuário',
  'Популярные магазины': 'Lojas populares',
  'Похожие купоны': 'Cupons Relacionados',
  'Предложений активно': 'Ofertas estão ativas',
  'промокод': 'Códigos',
  'Промокод не нужен': 'Cupom não é necessário',
  'Промокод сработал': 'Funcionou',
  'Промокод': 'Cupom de desconto',
  'Промокоды': 'Cupom de desconto',
  'Рейтинг': 'Avaliação',
  'сентябрь': 'setembro',
  'Сервисы для вебмастеров': 'Serviços para webmasters',
  'Скидки и акции': 'Descontos e promoções',
  'Скопировано': 'Copiado',
  'Скопируйте и вставьте этот код на': 'Copie e cole este código em',
  'Спасибо за ваш голос': 'Obrigado pelo seu voto',
  'Спорт': 'Desportes',
  'Стройка и ремонт': 'Construção e reparação',
  'Товары из Китая': 'Produtos da China',
  'Только сегодня': 'Só hoje',
  'Топ купонов': 'TOP cupons',
  'Туризм': 'Turismo',
  'Услуги': 'Serviços',
  'февраль': 'fevereiro',
  'Цветы и подарки': 'Flores e presentes',
  'ч.': 'h.',
  'Читать подробнее': 'Ler mais',
  'Электроника': 'Eletrónica',
  'январь': 'janeiro',
  'categories': 'categorias',
  'shops': 'lojas',
  'today': 'so-hoje',
}